export default {
  general: {
    send: 'span',
    loading: 'Loading',
  },
};
